module.exports = __webpack_public_path__ + "img/favicon.99c0f841.png";